<template>
  <main id="shuttle-unit-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('outbound.shuttleUnit.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="8" class="default-section-title">
              {{ $t('outbound.shuttleUnit.titleSummary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';

export default {
  name: 'ShuttleUnit',
  components: {
    SearchFilter,
    SearchSummary
  },
  data() {
    return {};
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>
